'use client'

import { Translation } from '@marketplace-web/i18n/i18n-data'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import ConversationTranslationButton from '../ConversationTranslationButton'

const TranslationButton = () => {
  const { conversation } = useConversationContext()

  const translationType = conversation?.translationType ?? Translation.None

  if (translationType === Translation.None) return null

  return <ConversationTranslationButton />
}

export default TranslationButton
